'use client'

import cx from 'classnames'
import React, { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'

export default function BaseAnimation({
  children,
  animationClassName,
  additionalClassName = '',
  rootMargin,
  once,
  invisible = false,
  isTransparent = false,
  animationDuration,
  delay = 0,
}: {
  children: React.ReactNode
  rootMargin: string
  animationClassName: string
  additionalClassName?: string
  once: boolean
  invisible?: boolean
  isTransparent?: boolean
  animationDuration?: string
  delay?: number
}) {
  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin,
    triggerOnce: once,
  })
  const [shouldStartAnimation, setShouldStartAnimation] = useState(false)

  useEffect(() => {
    if (once) {
      if (!shouldStartAnimation && inView) {
        setShouldStartAnimation(true)
      }
    } else {
      setShouldStartAnimation(inView)
    }
  }, [inView])

  return (
    <span
      ref={ref}
      className={cx('inline-block', additionalClassName, `${shouldStartAnimation ? animationClassName : ''}`, {
        visible: !invisible,
        'opacity-0': isTransparent,
      })}
      style={{
        animationDuration: animationDuration,
        ...(delay === 0 ? {} : { transitionDelay: `${delay}ms`, animationDelay: `${delay}ms` }),
      }}
    >
      {children}
    </span>
  )
}
